/**
 * Lightweight helpers for pages to share selected-item context
 * with the AI Assistant drawer via window.__aiContext.
 *
 * Usage:
 *   import { setAiContext, clearAiContext } from '../utils/aiContext';
 *
 *   // In a selection handler:
 *   setAiContext('part', { partId: p.part_id, partDescription: p.description });
 *
 *   // On unmount:
 *   useEffect(() => () => clearAiContext(), []);
 */

export function setAiContext(type, data) {
  window.__aiContext = { type, ...data };
}

export function clearAiContext() {
  window.__aiContext = null;
}
